import { EmailField } from "@inputs/text/EmailField";
import { Stack, type Theme, Typography, useMediaQuery } from "@mui/material";
import { type Control, Controller } from "react-hook-form";
import type { TEmailForm } from "./resolver";

interface ICcInputProps {
  control: Control<TEmailForm, void>;
  displayCc?: boolean;
}
export const CcInput = ({ control, displayCc }: ICcInputProps) => {
  const isTablet = useMediaQuery((theme: Theme) => theme.breakpoints.up("tablet"));
  if (displayCc) {
    return null;
  }

  return (
    <Stack
      direction={isTablet ? "row" : "column"}
      sx={{
        gap: isTablet ? 0 : 1,
        alignItems: isTablet ? "center" : "start",
      }}
    >
      <Typography
        sx={{
          minWidth: "7%",
        }}
      >
        Cc :
      </Typography>
      <Controller
        control={control}
        name="cc"
        render={({ field: { value, onChange, ref }, fieldState: { error } }) => (
          <EmailField
            value={value ?? []}
            onChange={onChange}
            size="small"
            fullWidth
            error={Boolean(error)}
            helperText={error?.message}
            inputRef={ref}
          />
        )}
      />
    </Stack>
  );
};
